import React from 'react';

type IconProps = {
  className?: string;
};

const baseClass = 'w-5 h-5';

export const IconWarningTriangle: React.FC<IconProps> = ({ className = baseClass }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth={1.6}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 3 2.5 19h19L12 3z" />
    <path d="M12 9v5" />
    <circle cx={12} cy={17} r={1} fill="currentColor" stroke="none" />
  </svg>
);

export const IconUsers: React.FC<IconProps> = ({ className = baseClass }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth={1.6}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx={8} cy={8} r={3} />
    <circle cx={16} cy={8} r={3} />
    <path d="M3.5 19c0-2.5 2.5-4.5 4.5-4.5s4.5 2 4.5 4.5" />
    <path d="M11.5 19c0-2.5 2.5-4.5 4.5-4.5s4.5 2 4.5 4.5" />
  </svg>
);

export const IconBox: React.FC<IconProps> = ({ className = baseClass }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth={1.6}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 8 12 3l9 5v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8z" />
    <path d="M3 8l9 5 9-5" />
    <path d="M12 13v8" />
  </svg>
);

export const IconChart: React.FC<IconProps> = ({ className = baseClass }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth={1.6}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 20h16" />
    <rect x={5.5} y={11} width={3} height={6} rx={1} />
    <rect x={10.5} y={6} width={3} height={11} rx={1} />
    <rect x={15.5} y={9} width={3} height={8} rx={1} />
  </svg>
);

export const IconCheckCircle: React.FC<IconProps> = ({ className = baseClass }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth={1.6}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx={12} cy={12} r={9} />
    <path d="m8.5 12 2.5 2.5 4.5-5" />
  </svg>
);

export const IconClipboard: React.FC<IconProps> = ({ className = baseClass }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth={1.6}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x={5} y={4} width={14} height={17} rx={2} />
    <path d="M9 4V3h6v1" />
    <path d="M9 9h6" />
    <path d="M9 13h6" />
    <path d="M9 17h3" />
  </svg>
);

export const IconDownload: React.FC<IconProps> = ({ className = baseClass }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth={1.6}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 4v10" />
    <path d="m7 10 5 5 5-5" />
    <path d="M5 19h14" />
  </svg>
);

export const IconCloudBackup: React.FC<IconProps> = ({ className = baseClass }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth={1.6}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M7 18a4 4 0 0 1 0-8 5.5 5.5 0 0 1 10.7-1.4A4.5 4.5 0 1 1 17 18H7z" />
    <path d="M12 12v6" />
    <path d="m9.5 15 2.5 2.5L14.5 15" />
  </svg>
);

export const IconTrendUp: React.FC<IconProps> = ({ className = baseClass }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth={1.6}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 17 10 11l3 3 7-7" />
    <path d="M14 7h6v6" />
  </svg>
);


export const IconNavDashboard: React.FC<IconProps> = ({ className = baseClass }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth={1.6}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 13h8V3H3v10z" />
    <path d="M13 21h8V11h-8v10z" />
    <path d="M13 3v6h8V3h-8z" />
    <path d="M3 21h8v-4H3v4z" />
  </svg>
);

export const IconNavUsers: React.FC<IconProps> = ({ className = baseClass }) => (
  <IconUsers className={className} />
);

export const IconNavInventory: React.FC<IconProps> = ({ className = baseClass }) => (
  <IconBox className={className} />
);

export const IconNavSales: React.FC<IconProps> = ({ className = baseClass }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth={1.6}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 6h18" />
    <path d="M8 6V5a4 4 0 1 1 8 0v1" />
    <path d="M5 6v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
  </svg>
);

export const IconNavFinance: React.FC<IconProps> = ({ className = baseClass }) => (
  <IconChart className={className} />
);

export const IconNavReports: React.FC<IconProps> = ({ className = baseClass }) => (
  <IconClipboard className={className} />
);

export const IconNavProfile: React.FC<IconProps> = ({ className = baseClass }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth={1.6}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx={12} cy={8} r={4} />
    <path d="M5 20c0-3.5 3-6 7-6s7 2.5 7 6" />
  </svg>
);

export const IconNavExpenses: React.FC<IconProps> = ({ className = baseClass }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth={1.6}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 3h18v18H3z" />
    <path d="M3 9h18" />
    <path d="M9 3v18" />
    <path d="M7 13h10" />
    <path d="M7 17h8" />
  </svg>
);
